import { createSlice } from '@reduxjs/toolkit';

import { type AnimateNftEventAction, type PodEventsState } from './types';

const name = 'podEvents';

const initialState: PodEventsState = {
    events: [],
    sold: [],
};

const emptyState: Omit<PodEventsState, 'sold'> = {
    events: [],
};

export const podEventsSlice = createSlice({
    name,
    initialState,
    reducers: {
        animateNftEvent(state, { payload }: AnimateNftEventAction) {
            state.events = [...state.events, payload];
        },
        clearNftEvents(state) {
            return { ...state, ...emptyState };
        },
    },
});
